export const isEmptyArray = (arr) => !Array.isArray(arr) || arr.length === 0;
